
import '../Services.css';
import img from '../../../assets/catogory/Apartments/img1.jpg'; // Apartment/Building image
import PropertyAdvantage from '../../../components/PropertyAdvantage/PropertyAdvantage';
import ConversationSection from '../../../components/ConversationSection/ConversationSection';

const PropertyManagement = () => {
    return (
        <div className="service-page">
            <div className="service-hero">
                <h1>Property Management</h1>
            </div>
            <section className="service-split-section">
                <div className="service-split-container">
                    <div className="service-left">
                        <span className="service-badge-pill">Success, Together</span>
                        <h2 className="service-split-title">Property Management</h2>
                        <p className="service-split-text">
                            At Jeevan Realty, we simplify every aspect of property management—allowing you to enjoy the benefits of ownership without the hassle. From tenant acquisition and maintenance to legal compliance, our comprehensive services ensure your asset is well-protected and profitable.
                        </p>
                    </div>
                    <div className="service-right">
                        <img src={img} alt="Property Management" />
                    </div>
                </div>
            </section>

            <div className="service-steps-container">
                <div className="service-steps-list">
                    {/* Step 1 */}
                    <div className="service-step-card">
                        <div className="service-step-number">1</div>
                        <div className="service-step-content">
                            <h3>Property Assessment</h3>
                            <p>We conduct a thorough inspection of your property to determine its rental value and identify any necessary improvements.</p>
                        </div>
                    </div>

                    {/* Step 2 */}
                    <div className="service-step-card">
                        <div className="service-step-number">2</div>
                        <div className="service-step-content">
                            <h3>Marketing & Tenant Search</h3>
                            <p>Our team effectively markets your property and screens potential tenants to ensure reliability and suitability.</p>
                        </div>
                    </div>

                    {/* Step 3 */}
                    <div className="service-step-card">
                        <div className="service-step-number">3</div>
                        <div className="service-step-content">
                            <h3>Lease Management</h3>
                            <p>We handle lease drafting, signing, and renewals, ensuring all agreements comply with local rental laws.</p>
                        </div>
                    </div>

                    {/* Step 4 */}
                    <div className="service-step-card">
                        <div className="service-step-number">4</div>
                        <div className="service-step-content">
                            <h3>Rent Collection</h3>
                            <p>We ensure timely rent collection and facilitate easy payment methods for tenants, creating a steady income stream for you.</p>
                        </div>
                    </div>

                    {/* Step 5 */}
                    <div className="service-step-card">
                        <div className="service-step-number">5</div>
                        <div className="service-step-content">
                            <h3>Maintenance & Repairs</h3>
                            <p>Our team coordinates all routine maintenance and emergency repairs, preserving the condition and value of your property.</p>
                        </div>
                    </div>

                    {/* Step 6 */}
                    <div className="service-step-card">
                        <div className="service-step-number">6</div>
                        <div className="service-step-content">
                            <h3>Financial Reporting</h3>
                            <p>We provide detailed financial reports and statements, giving you full transparency into your property's performance.</p>
                        </div>
                    </div>
                </div>
            </div>

            <PropertyAdvantage />
            <ConversationSection />
        </div >
    );
};

export default PropertyManagement;
